// retool/erp/ops/get-bulk-orders-for-approval

import { createSlice } from '@reduxjs/toolkit';

import { getOpsAllPendingOrders, placeManualReorders } from '../../apis';

export const OpsAllPendingOrders = createSlice({
    name: 'opsAllPendingOrders',
    initialState: {
        opsAllPendingOrdersIsLoading: false,
        opsNewReorderSuccessMessage: '',
        data : [],
        error: ''
    },

    reducers: {
        clearErrorState: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clear: (state, action) => {
            if (action.payload.key) {
                return {...state, [action.payload.key]: action.payload.value}
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getOpsAllPendingOrders.pending, (state, action) => {
            state.opsAllPendingOrdersIsLoading = true;
        })
        builder.addCase(getOpsAllPendingOrders.fulfilled, (state, action) => {
            state.opsAllPendingOrdersIsLoading = true;
            state.error = '';
            state.data = action.payload.data
        })
        builder.addCase(getOpsAllPendingOrders.rejected, (state, action) => {
            state.error = action.payload.message
            state.opsAllPendingOrdersIsLoading = false;
        })
        builder.addCase(placeManualReorders.pending, (state, action) => {
            state.opsNewReorderSuccessMessage = '';
        })
        builder.addCase(placeManualReorders.fulfilled, (state, action) => {
            state.opsNewReorderSuccessMessage = action.payload.data.message;
            state.error = '';
        })
        builder.addCase(placeManualReorders.rejected, (state, action) => {
            state.error = action.payload.message
            state.opsNewReorderSuccessMessage = '';
        })
        
    }
})

export const { clearErrorState, clear } = OpsAllPendingOrders.actions
export default OpsAllPendingOrders.reducer